module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-123.23f98cea.svg";